import { IFile } from "./IFile";

export enum UploadMode {
	SINGLE = "single",
	MULTIPLE = "multiple",
}

export enum MediaAccepted {
	IMAGE = "image",
	VIDEO = "video",
	IMAGE_VIDEO = "image/video",
	AUDIO = "audio",
}

export enum UploadFormat {
	IMAGE = "image/gif, image/jpeg, image/jpg, image/svg, image/png, image/webp",
	VIDEO = "video/mp4, video/ogg, video/webm",
	AUDIO = "audio/mp3, audio/mp3, audio/m4a, audio/aac, audio/wav, audio/oga, audio/ogg, audio/wma, audio/flac",
}

export interface IUploadContext {
	mode?: UploadMode;
	path?: string;
	files?: IFile[];
	maxSize?: number;
	format?: UploadFormat;
	isSimpleImage?: boolean;
	isProfile?: boolean;
	isPost?: boolean;
	viewFull?: boolean;
	viewWidth?: number;
	viewHeight?: number;
	maxFileCount?: number;
	mediaAccepted?: MediaAccepted;
	folder?: string;
	subfolder?: string;
	useMediaObject?: boolean;
}
